module.exports = __webpack_public_path__ + "img/cs3.5df370ae.png";